import axios from "axios";
import { GURL } from "./global";

axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
  "token"
)}`;

// Service for fetching invitations with OData query parameters
export const GetNoticesOData = (
  top: number = 1000,
  skip: number = 0,
  orderBy: string = "",
  filters: string = "",
  tab = 1
) => {
  const url = `${GURL}/Notice/odata/NoticesOData?tab=${tab}&$top=${top}&$skip=${skip}&$count=true&$expand=Category&${orderBy}&${filters}`;
  return axios.get(url);
};
